import OnboardingNav from "../../components/OnboardingNav/OnboardingNav";

export default function OnboardingLayout({ children, hasProgress, progress }) {//overflow-y-hidden
  return (
    <div className="w-full h-screen flex flex-col bg-gray-50"> 
      <OnboardingNav hasProgress={hasProgress} progressProp={progress}/>
      <div className="w-full grow bg-gray-100 pt-12 pb-20 md:py-[64px] relative">
        {children}
      </div>
    </div>
  );
}
